import { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import sidebarArrow from '../assets/img/sidebarArrow.png'
import { GraphicEq, Equalizer, PeopleAlt, Assessment, Translate, Explore, ExitToApp, AttachMoney, GroupWork, FindReplace, ChevronRight, ChevronLeft, HeadsetMic } from '@material-ui/icons';
import { Link } from "react-router-dom";
// import Logo from '../assets/img/logo.svg';
import Logo from '../assets/img/new-bleat-logo.png';

import AuthContext from '../store/AuthContext.js';
import UsersContext from '../store/UsersContext';
import SidebarContext from '../store/SidebarContext.js';
import SearchIcon from '@mui/icons-material/Search';


import '../App.scss';
import { East } from '@mui/icons-material';

const noSideBarRoutes = ["/login", "/register", "/builder"];

function SideBar() {

  const authCtx = useContext(AuthContext);
  const { canAccessAdministrators, canAccessOverview } = authCtx;
  const showAdministratorsLink = canAccessAdministrators;
  const showOverviewLink = canAccessOverview;
  const overviewRoute = "/overviewv2";
  const usersCtx = useContext(UsersContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // console.log(pathname);

  const isLoggedIn = authCtx.isLoggedIn;

  const [isLoading, setIsLoading] = useState(true);
  const [assessments, setAssessments] = useState([]);
  const [filteredAssessments, setFilteredAssessments] = useState([]);
  const [hideActive, setHideActive] = useState("");
  const [currentAssessment, setCurrentAssessment] = useState(null);
  const [currentChildAssessment, setCurrentChildAssessment] = useState(null);
  const sidebarCtx = useContext(SidebarContext);
  const [isHidden, setIsHidden] = useState(false);
  const [versionChildName, setVersionChildName] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  

  useEffect(() => {
    getAssessments();
  }, []);

  useEffect(() => {
    if (!pathname) return;
  
    const path = pathname.split("/").filter(Boolean); // remove empty segments
    const routeType = path[0]; // e.g. "assessmentsdashboard" or "assessmentsv2"
    const id = path[1]; // e.g. "78"
  
    // --- Special-case redirect for Quadrant Flow (id 78) ---
    // If someone tries to open /assessmentsv2/78, immediately replace with /assessmentsdashboard/78
    // (this only runs for id '78' so other assessments are unaffected)
    if (id && id.toString() === "78" && routeType === "assessmentsv2") {
      navigate(`/assessmentsdashboard/${id}`, { replace: true });
      return; // exit effect so we don't run the rest of the logic during the redirect
    }
  
    // default clear
    setVersionChildName("");
    setCurrentChildAssessment(null);
  
    if (id) {
      setCurrentAssessment(Number(id));
      setHideActive("");
  
      // prefer to find the assessment in state (so we can inspect boLinks)
      const ass = assessments.find(a => a?.id?.toString() === id?.toString());
  
      // normalized route we compare with what's built in assessmentBOV1V2ItemRender
      const normalizedRoute = `/${routeType}/`;
  
      if (ass && Array.isArray(ass.boLinks) && ass.boLinks.length > 0) {
        // try to match the route to one of the boLinks for this assessment
        const matchedLink = ass.boLinks.find(l => (`/${l.link}/`) === normalizedRoute);
        if (matchedLink) {
          // store the same string that the render code compares against:
          setVersionChildName(normalizedRoute);
        }
      } else {
        // fallback to existing special-case mapping (retain your old behaviour)
        if (routeType === "assessmentsparishinsights") {
          setVersionChildName("Parish Insights");
        } else if (routeType === "assessmentschurchinsights") {
          setVersionChildName("Church Insights");
        } else if (routeType === "dashboard" || routeType === "assessmentsdashboard") {
          setVersionChildName(normalizedRoute);
        } else {
          setVersionChildName("");
        }
      }
    } else {
      // no id in path => collapsed/none selected
      setHideActive(" hide-active");
    }
  }, [pathname, assessments, navigate]);
  
  

  const isHiddenBoVersion = (assessment) =>
    String(assessment?.boVersion || '').trim().toLowerCase() === 'none';

  useEffect(() => {
    const delay = setTimeout(() => {
      const visibleAssessments = (assessments || []).filter((a) => !isHiddenBoVersion(a));
      if (searchTerm?.trim()?.length > 0) {
        const filtered = visibleAssessments.filter(a =>
          a?.title?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredAssessments(filtered);
      } else {
        setFilteredAssessments(visibleAssessments);
      }
    }, 300); // debounce delay in ms

    return () => clearTimeout(delay);
  }, [searchTerm, assessments]);

  const getAssessments = () => {
    setIsLoading(true)
    fetch(process.env.REACT_APP_API_URI + "/v6/admin/assessment/byAccount/" + authCtx.accountId, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + authCtx.token
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setIsLoading(false);
        const responseData = data?.data;
        const accountAssessments = Array.isArray(responseData)
          ? responseData.filter((item) => item?.support_enabled === undefined)
          : responseData?.assessments || [];
        // boVersion "none" = hide from sidebar (still available elsewhere if needed)
        const sidebarAssessments = accountAssessments.filter(
          (item) => String(item?.boVersion || '').trim().toLowerCase() !== 'none'
        );
        setAssessments(sidebarAssessments);
        setFilteredAssessments(sidebarAssessments);
        // console.log("data", assessments);
      })
      .catch((error) => {
        console.error("Error fetching sidebar assessments:", error);
        setIsLoading(false);
      });
  }

  if (noSideBarRoutes.some((item) => pathname.includes(item))) return null;

  return (
    <div className={sidebarCtx.isOpen ? 'menu close-sidebar' : 'menu'}>
      <div className="logo-arrow-container" style={{ flexDirection: sidebarCtx.isOpen ? "column-reverse" : "" }}>
        <div className={sidebarCtx.isOpen ? "company-logo company-logo-closed" : "company-logo"}>
          <img src={Logo} alt="company logo" />
        </div>
        <div className="sidebar-arrow" >
          {
            sidebarCtx.isOpen ? <div className='right-arrow-logo' onClick={() => {
              sidebarCtx.toggleSidebar();
              if (isHidden) { setIsHidden(false) }
              else { setTimeout(() => { setIsHidden(true); }, 400); }
            }}> <ChevronRight /> </div> : <div className="left-arrow-logo" onClick={() => {
              sidebarCtx.toggleSidebar()
              if (isHidden) { setIsHidden(false) }
              else { setTimeout(() => { setIsHidden(true); }, 400); }
            }}><ChevronLeft /></div>
          }
        </div>
      </div>
      <div className="search-wrapper" style={{display : isHidden ? "none" : ""}}>
        <span className="search-icon"><SearchIcon fontSize="small" /></span>
        <input type="search" className="search-input with-icon" placeholder="Search assessments..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
      </div>   
      <nav>
        {/* {isLoggedIn && !sidebarCtx.isOpen ? (<h3 className="welcome-user">Welcome,<br/>{authCtx?.userName?.split(" ")[0]}!</h3>) : <></>} */}

        {/* 	<h4 className="assessments-header">Assessments:</h4> */}

        <div className={authCtx.accountId == 0 ? "assessments-list" : "assessments-list account"} 
        style={{ height: (showAdministratorsLink || showOverviewLink) ? "calc(100vh - 420px)" : "calc(100vh - 360px)" }}
        >
          <ul>
            {
              filteredAssessments?.map((assessment, index) => {
                let activeClass = "";
                let childrenClass = "";
                let replace = /Church Management Software/gi;
                let assessmentNameFull = assessment?.title.toString();
                let assessmentName = assessment?.title.toString().replace(replace, "ChMS").trim();
                assessmentName = assessmentName.length > 24 ? assessmentName.substring(0, 24) + "..." : assessmentName;
                if (assessment?.id?.toString() === currentAssessment?.toString()) {
                  activeClass = " active-assessment ";
                  childrenClass = "assessment-dropdown-active"
                } else {
                  activeClass = "";
                  childrenClass = "assessment-dropdown-hide"
                }

                return (
                  <div key={assessment?.id ?? `assessment-${index}`}>
                    {assessment?.boVersion !== 'v1' ? assessmentBOV1V2Item(assessment, assessmentNameFull, activeClass, index, assessmentName)
                      : <li title={assessmentNameFull} style={isHidden ? { display: "flex", justifyContent: "center" } : {}} key={assessment?.id} onClick={() => navigate("/assessments/" + assessment?.id, { replace: true })}>

                        <div className={"assessment-item" + activeClass + hideActive}>
                          <span className="assessment-num" style={{ marginRight: isHidden ? "0" : "" }}>{index + 1} </span>
                          {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> {assessmentName}</span>}
                        </div>

                        <div className={childrenClass}>
                          <ul style={assessment?.childrenAssessments?.length === 0 ? { display: "none" } : {}}>
                            <li onClick={() => { navigate("/assessments/" + assessment?.id, { replace: true }) }} style={(currentAssessment?.toString() === assessment?.id.toString() && currentChildAssessment === null) ? { padding: '0 0 7px 0', fontWeight: 'bold' } : { padding: '0 0 7px 0' }}>All Assessments</li>
                            {assessment?.childrenAssessments?.map((item, index) => <li style={(currentChildAssessment?.toString() === item?.id?.toString()) ? { padding: '7px 0', fontWeight: 'bold' } : { padding: '7px 0' }} key={item?.id ?? `child-${assessment?.id}-${index}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (item.assessment_type === "simple") {
                                  navigate("/assessmentsv2/" + item?.id, { replace: true });
                                } else navigate("/assessments/" + item?.id, { replace: true });
                              }}>{item.title}</li>)}
                          </ul>
                        </div>
                      </li>
                    }
                  </div>
                )
              })
            }
            { !isLoading && filteredAssessments?.length === 0 && <p className='no-data-found'>No Results found</p>}
          </ul>
        </div>

        <div className="bottom-links" style={sidebarCtx.isOpen ? { left: "1%" } : {}}>
          <div className="links-container">
            {
              authCtx.accountId == 0 ? <>
                {showOverviewLink && <Link to={overviewRoute} className="nav-link"><Equalizer />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Overview </span>} </Link>}
                <Link to="/clients" className="nav-link"><PeopleAlt />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Clients </span>} </Link>
                {showAdministratorsLink && <Link to="/administrators" className="nav-link"><PeopleAlt />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Administrators </span>} </Link>}
                <Link to="/assessments" className="nav-link"><Assessment />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Assessments </span>} </Link>
                {/* <Link to="/engagement" className="nav-link"><GraphicEq />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Landing Pages </span>} </Link> */}
                {/* <Link to="/datamining" className="nav-link"><FindReplace />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Data Mining </span>} </Link> */}
              </> : null
            }
            {authCtx.accountId != 0 && showOverviewLink && (
              <Link to={overviewRoute} className="nav-link"><Equalizer />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Overview </span>} </Link>
            )}
            {authCtx.accountId != 0 && showAdministratorsLink && (
              <Link to="/administrators" className="nav-link"><PeopleAlt />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Administrators </span>} </Link>
            )}
            <Link to="/support-center" className="nav-link"><HeadsetMic />&nbsp;&nbsp; {isHidden ? <></> : <span className={`fade-out ${sidebarCtx.isOpen ? 'fade-in' : ''}`}> Support Center </span>} </Link>
            {/* <a className="logout" onClick={() => authCtx.logout()}><div className="lower-icon"><ExitToApp style={{color: "#212A42", fontSize: "18px"}} /></div> Log out</a> */}
            <a className="logout" onClick={() => authCtx.logout()}><ExitToApp />&nbsp;&nbsp;{isHidden ? <></> : <span style={{ opacity: sidebarCtx.isOpen ? "0" : "1", transition: '1s' }} >Log Out</span>}</a>
          </div>
        </div>
      </nav>

    </div>
  );

  //! TODO: refactor all of this navigation & Sidebar logic, everything needed should come from the API
  // function assessmentBOV1V2Item(assessment, assessmentNameFull, activeClass, index, assessmentName) {

  //   switch (assessment?.id) {

  //     case 50:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 50, activeClass, index, [assessmentName, 'Parish Insights'], ['/assessmentsv2/', '/assessmentsparishinsights/']);
  //     case 71:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 71, activeClass, index, [assessmentName, 'Backoffice v2'], ['/assessments/', '/assessmentsv2/']);
  //     case 73:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 73, activeClass, index, [assessmentName, 'Backoffice v2'], ['/assessments/', '/assessmentsv2/']);
  //     case 74:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 74, activeClass, index, [assessmentName, 'Church Insights'], ['/assessmentsv2/', '/assessmentschurchinsights/']);
  //     case 78:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 78, activeClass, index, [assessmentName, "Main", 'Dashboard', 'Consultants', 'Clients', 'Assessments', 'Tokens'], ['/assessments/', '/assessmentsmain/', '/assessmentsdashboard/', '/assessmentsconsultants/', '/assessmentsclients/', '/assessmentsassessments/', '/assessmentstokens/']);
  //     case 83:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 83, activeClass, index, [assessmentName, 'Backoffice v2'], ['/assessments/', '/assessmentsv2/']);
  //     case 84:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 84, activeClass, index, [`${assessmentName} v2`], ['/assessmentsv2/']);
  //     case 86:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 86, activeClass, index, [assessmentName, 'Backoffice v2'], ['/assessments/', '/assessmentsv2/']);
  //     case 94:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 94, activeClass, index, [assessmentName], ['/assessmentsv2/']);
  //     case 95:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 95, activeClass, index, [`${assessmentName}`], ['/assessmentsv2/']);
  //     case 104:
  //       return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, 104, activeClass, index, [`${assessmentName}`], ['/assessmentsv2/']);
  //     default:
  //       break;
  //   }
  // }


  function assessmentBOV1V2Item(assessment, assessmentNameFull, activeClass, index, assessmentName) {
    const { id, boVersion, boLinks } = assessment;

    switch (boVersion) {
      case 'v1-v2':
        // if(id == 50){
        //   return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName, 'Parish Insights'], ['/assessmentsv2/', '/assessmentsparishinsights/']);
        // }
        // if(id === 74){
        //   return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName, 'Church Insights'], ['/assessmentsv2/', '/assessmentschurchinsights/']);
        // }
        // if(id === 78){
        //   return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName, "Main", 'Dashboard', 'Consultants', 'Clients', 'Assessments', 'Tokens'], ['/assessments/', '/assessmentsmain/', '/assessmentsdashboard/', '/assessmentsconsultants/', '/assessmentsclients/', '/assessmentsassessments/', '/assessmentstokens/']);
        // }
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName, 'Backoffice v2'], ['/assessments/', '/assessmentsv2/']);

      case 'v2':
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName], ['/assessmentsv2/']);

      case 'v1':
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName], ['/assessments/']);

      case 'parent':
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName, 'Parent Group'], ['/assessments/parent/']);

      case 'custom':
        // console.log("path", boLinks);
        // console.log("path", boLinks.map(link => '/' + link.link + '/'));
        let urls = ['/assessmentsv2/', ...boLinks.map(link => {
        return link.link.includes('/') ? `/${link.link}` : `/${link.link}/`;
        })];
        let assessmentNames = [assessmentName, ...boLinks.map(link => link.title)];
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, assessmentNames, urls);

      case 'none':
        // Intentionally hidden from sidebar
        return null;
          
      default:
        return assessmentBOV1V2ItemRender(assessment, assessmentNameFull, id, activeClass, index, [assessmentName], ['/assessmentsv2/']);
    }
  }


  function assessmentBOV1V2ItemRender(
    assessment,
    assessmentNameFull,
    itemId,
    activeClass,
    index,
    assessmentNamesList,
    navigationLinkList
  ) {
    // console.log("assessmentNamesList", assessmentNamesList);
    // console.log("navigationLinkList", navigationLinkList);
    return (
      <div key={assessment?.id ?? itemId} style={currentAssessment === itemId ? { backgroundColor: "#0F131D" } : {}}>
        <li title={assessmentNameFull} style={isHidden ? { display: "flex", justifyContent: "center" } : {}} onClick={() => {
          setVersionChildName("");
          const navState = assessment?.id === 108 ? { accountOnly: true } : undefined;
          navigate(`${navigationLinkList[0]}${assessment?.id}`, { replace: true, state: navState });
        }}>
          <div className={ "assessment-item" + (versionChildName === "" && currentAssessment === itemId ? activeClass : "") + hideActive }>
            <span className="assessment-num" style={{ marginRight: isHidden ? "0" : "" }} > {index + 1} </span>
            {!isHidden && (
              <span className={`fade-out ${sidebarCtx.isOpen ? "fade-in" : ""}`}>
                {assessmentNamesList[0]}
              </span>
            )}
          </div>

          <div className="assessment-dropdown-active">
            <ul style={{ display: "block" }}>
              {navigationLinkList.slice(1).map((item, idx) => (
                <li
                  key={`${assessment?.id ?? itemId}-${item}-${idx}`}
                  title=""
                  onClick={(e) => {
                    e.stopPropagation();
                    setVersionChildName(item);
                    const link = navigationLinkList[idx + 1];

                    const destination = link.endsWith('/') ? `${link}${assessment?.id}` : link;
                    const navState = assessment?.id === 108 ? { accountOnly: false } : undefined;
                    navigate(destination, { replace: true, state: navState });
                  }}
                  style={
                    versionChildName === item && currentAssessment === itemId
                      ? { fontWeight: "bold", color: "#F2D466" }
                      : {}
                  }
                >
                  {assessmentNamesList[idx + 1]}
                </li>
              ))}
            </ul>
          </div>
        </li>
      </div>
    );
  }

}

export default SideBar;
